import React from 'react';
import { Button, Icon, ButtonGrid } from '../';

export function AnchorAlignmentButtons({ handler: alignAnchor }) {
    return (
      <ButtonGrid rows={3} cols={3}>
        <Button
          size="xs"
          color="secondary"
          onClick={() => alignAnchor('topleft')}
        >
          <Icon
            icon="far fa-arrow-up fa-fw"
            style={{ transform: 'rotate(-45deg)' }}
          />
        </Button>
        <Button
          size="xs"
          color="secondary"
          onClick={() => alignAnchor('topcenter')}
        >
          <Icon icon="far fa-arrow-up fa-fw" />
        </Button>
        <Button
          size="xs"
          color="secondary"
          onClick={() => alignAnchor('topright')}
        >
          <Icon
            icon="far fa-arrow-up fa-fw"
            style={{ transform: 'rotate(45deg)' }}
          />
        </Button>
        <Button
          size="xs"
          color="secondary"
          onClick={() => alignAnchor('centerleft')}
        >
          <Icon
            icon="far fa-arrow-up fa-fw"
            style={{ transform: 'rotate(-90deg)' }}
          />
        </Button>
        <Button
          size="xs"
          color="secondary"
          onClick={() => alignAnchor('centercenter')}
        >
          <Icon icon="far fa-dot-circle fa-fw" />
        </Button>
        <Button
          size="xs"
          color="secondary"
          onClick={() => alignAnchor('centerright')}
        >
          <Icon
            icon="far fa-arrow-up fa-fw"
            style={{ transform: 'rotate(90deg)' }}
          />
        </Button>
        <Button
          size="xs"
          color="secondary"
          onClick={() => alignAnchor('bottomleft')}
        >
          <Icon
            icon="far fa-arrow-up fa-fw"
            style={{ transform: 'rotate(-135deg)' }}
          />
        </Button>
        <Button
          size="xs"
          color="secondary"
          onClick={() => alignAnchor('bottomcenter')}
        >
          <Icon
            icon="far fa-arrow-up fa-fw"
            style={{ transform: 'rotate(180deg)' }}
          />
        </Button>
        <Button
          size="xs"
          color="secondary"
          onClick={() => alignAnchor('bottomright')}
        >
          <Icon
            icon="far fa-arrow-up fa-fw"
            style={{ transform: 'rotate(135deg)' }}
          />
        </Button>
      </ButtonGrid>
    );
  }
  